import Column from 'layout/Components/Column'
import { RowBetween } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import theme from 'theme'
import { FlexProps } from 'UIKit/Box/types'
import Text, { TextProps } from 'UIKit/Text'

export const ExtraInfoLabel: React.FC<React.PropsWithChildren<TextProps>> = ({ ...props }) => (
  <Text
    color={`var(--pm-text-note-color, ${theme.colors.textAlt699})`}
    fontSize="var(--pm-text-note-size)"
    lineHeight={1.4}
    {...props}
  />
)

export const ExtraInfoGroup: React.FC<
  React.PropsWithChildren<
    FlexProps & {
      gap?: string
    }
  >
> = ({ ...props }) => <Column gap="8px" {...props} />

export const ExtraInfoItem: React.FC<
  React.PropsWithChildren<Omit<TextProps, 'title'> & { title?: string; hide?: boolean; side?: 'right' | 'left' }>
> = ({ children, title, hide = false, side, ...props }) =>
  !hide && (
    <RowBetween {...props}>
      {title && (
        <ExtraInfoLabel>
          <Trans>{title}</Trans>
        </ExtraInfoLabel>
      )}
      <Text width="auto" textAlign={side} fontSize="var(--pm-text-note-size)" lineHeight={1.4}>
        {children}
      </Text>
    </RowBetween>
  )

const ExtraInfo: React.FC<
  React.PropsWithChildren<
    {
      childHeight?: number
      defaultOpen?: boolean
      hide?: boolean
    } & FlexProps
  >
> = ({ children, hide = false, ...props }) => {
  return !hide && <ExtraInfoGroup {...props}>{children}</ExtraInfoGroup>
}

export default ExtraInfo
